import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import Table from "@mui/material/Table";
import GitHubIcon from "@mui/icons-material/GitHub";
import {
  TableCell,
  TableContainer,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
import TableStyle from "../../styles/table.style";
import Input from "../../components/Input";
import ButtonLoading from "../../components/ButtonLoading";
import { convertStringToDatePTBR } from "../../utils/dateUtils";
import Copyright from "../../components/Copyright";
import { RepositoryTypes } from "../../interfaces/RepositoryTypes";
import { colors } from "../../assets/colors";
import Row from "../../components/layout/Row";

interface Props {
  loading: boolean;
  repositories: RepositoryTypes[];
  nickName: string;
  setNickName: (nickName: string) => void;
  repositoryName: string;
  setRepositoryName: (repositoryName: string) => void;
  pipeline: string;
  setPipeline: (pipeline: string) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

export default function RepositoriesScreen({
  loading,
  repositories,
  nickName,
  setNickName,
  repositoryName,
  setRepositoryName,
  pipeline,
  setPipeline,
  handleSubmit,
}: Props) {
  const columns = [
    { id: "nick_name", label: "Apelido", minWidth: 100 },
    { id: "repository", label: "Repositório", minWidth: 100 },
    { id: "peppeline", label: "Pipeline", minWidth: 100 },
    { id: "create_at", label: "Criado em", minWidth: 100 },
  ];

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: colors.white,
        flexGrow: 1,
        height: "100vh",
        overflow: "auto",
      }}
    >
      <Toolbar />
      <Box sx={{ padding: 6 }}>
        <Title text="Repositórios" icon={<GitHubIcon color="primary" />} />

        <Box component={"form"} onSubmit={handleSubmit}>
          <Row
            style={{
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              gap: 6,
            }}
          >
            <Input
              title={"Repositório"}
              placeholder={"Ex: qazando-appium-mobile"}
              value={repositoryName}
              onChange={(e) => setRepositoryName(e.target.value)}
              required
            />

            <Input
              title={"Pipeline"}
              placeholder={"Ex: regressivo.yml"}
              value={pipeline}
              onChange={(e) => setPipeline(e.target.value)}
              required
            />

            <Input
              title={"Apelido"}
              placeholder={"Ex: Regressivo e2e"}
              value={nickName}
              onChange={(e) => setNickName(e.target.value)}
              required
            />

            <ButtonLoading
              label="Adicionar repositório"
              loading={loading}
              style={{ width: 200, height: 50, marginTop: 37 }}
            />
          </Row>
        </Box>

        {/* GRID */}
        <Paper sx={{ width: "100%", mt: 8 }}>
          <TableContainer sx={{ maxHeight: 900 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{
                      top: 57,
                      minWidth: column.minWidth,
                      backgroundColor: "#F5F6FA",
                      color: "#9FA2B4",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
              <TableBody>
                {repositories.map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      <TableCell style={TableStyle.row}>
                        {row.nick_name}
                      </TableCell>
                      <TableCell style={TableStyle.row}>
                        {row.repository_name}
                      </TableCell>
                      <TableCell style={TableStyle.row}>
                        {row.pipeline}
                      </TableCell>
                      <TableCell style={TableStyle.row}>
                        {convertStringToDatePTBR(row.create_at)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Copyright />
      </Box>
    </Box>
  );
}
